export default {
  getAll: {
    url: '/api/sms/getAll',
    method: 'get'
  },
  create: {
    url: '/api/sms/create',
    method: 'post'
  },
  update: {
    url: '/api/sms/update',
    method: 'put'
  },
  delete: {
    url: '/api/sms/delete',
    method: 'delete'
  }
}



// WEBPACK FOOTER //
// ./src/api/sms.js